import React from 'react';

/**
 * Hook used to delay the state update for a value that updates frequently
 *
 * @param {any} value Updated value
 * @param {number=} delay Delay in milliseconds
 * @returns {any} Delayed updated state value
 */
const useDebounce = (value, delay = 500) => {
  const [debounceValue, setDebounceValue] = React.useState(value);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [delay, value]);

  return debounceValue;
};

export default useDebounce;
